export const DELIVERY_DECISIONS = {
  created: 'Queued for sending',
  denied: 'Not sent',
  already_sent: 'Not sent: already sent before, updates are off',
} as const

export type DeliveryDecision = keyof typeof DELIVERY_DECISIONS

export const DENIAL_REASONS = {
  leads_limit: 'monthly leads limit reached',
  segment_mismatch: "doesn't match the workflow's segment",
  contacts_required: 'workflow needs contacts, customer has no contact provider or credits',
  credit_limit: 'ran out of contact credits during lookup',
} as const

export type DenialReason = keyof typeof DENIAL_REASONS

export const DELIVERY_EVENT_TYPES = {
  ...DELIVERY_DECISIONS,
  repeated: 'Same lead received again (ignored)',
  waiting_for_contacts: 'Waiting for contacts',
  contacts_ready: 'Contacts found',
  dropped: 'Not sent',
  delayed_until: "Delayed by the workflow's delay setting",
  handed_off: 'Passed to the integration sender',
} as const

export type DeliveryEventType = keyof typeof DELIVERY_EVENT_TYPES

export const DELIVERY_OUTCOME_FILTERS = {
  sent: 'Sent',
  not_sent: 'Not sent',
  not_sent_except_segment_mismatch: 'Not sent except segment mismatch',
} as const

export type DeliveryOutcomeFilter = keyof typeof DELIVERY_OUTCOME_FILTERS
